<template>
  <nav class="header-nav">
    <div class="nav-block"></div>
    <div class="header-nav__end">
      <div class="nav-block">
        <a
          class="header-nav__link"
          href="https://campusmoviefest.com/opportunities"
        >
          Participate
        </a>
        <a class="header-nav__link" href="https://campusmoviefest.com/movies">
          Watch
        </a>
        <a class="header-nav__link" href="https://campusmoviefest.com/support">
          Support
        </a>
        <a class="header-nav__link" href="https://live.campusmoviefest.com">
          Premiere
        </a>
        <a
          class="header-nav__link"
          href="https://live.campusmoviefest.com/workshops"
        >
          Workshops
        </a>
        <a class="header-nav__link" href="https://campusmoviefest.com/about">
          About
        </a>
        <a class="header-nav__link" @click="logout()" v-if="currentUser"
          >Logout</a
        >
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "HeaderNav",
  data() {
    return {
      signInModal: false
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    openAuthModal() {
      this.$root.$emit("auth");
    }
  }
};
</script>

<style scoped lang="scss">
.header-nav {
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;

  &__end {
    display: flex;
    align-items: center;
    height: 100%;
  }

  &__link {
    display: inline-block;
    font-size: 14px;
    margin-right: 2.857em;
    font-weight: 400;
    text-transform: uppercase;
    text-decoration: none;
    transition: 0.3s;
    border-bottom: 0.14286em solid transparent;
    letter-spacing: 0.166em;

    @media screen and (max-width: 1100px) {
      font-size: 10px;
    }

    &:last-child {
      margin-right: 0;
    }

    &.router-link-active,
    &:hover {
      border-color: $cmf-blue;
    }

    &:not(.router-link-active):hover {
      color: $primary;
    }
  }
}

.v-btn::v-deep {
  &.v-size--default {
    font-weight: 500;
    font-size: 16px !important;
    letter-spacing: 0.1em;
    border-radius: 0;
  }
  &:not(.v-btn--round).v-size--default {
    height: 100%;
    padding: 0 40px;
  }
}

@media screen and (max-width: 960px) {
  .nav-block {
    display: none !important;
  }

  .header-nav__end {
    width: 100%;
    justify-content: flex-end;
  }

  .header-nav {
    display: none;
  }
}
</style>
